function payWithSber(login_, orderId, price, onError) {
  try {
    var API_URL = 'https://lk-api.freedom-vrn.ru:2443/lk/api/v1'

    // параметр redirect_url, по идее, надо из параметров запроса убрать
    var REDIRECT_URL =
      window.location.protocol + '//' + window.location.host + window.location.pathname

    // адрес изображения, которое должно установить Cookie для pay.freedom-vrn.ru
    // для последующего редиректа на REDIRECT_URL
    // var ROBOKASSA_REGISTER_REDIRECT_URL_IMG =
    // 'https://lk-api.freedom-vrn.ru/robokassaRegisterRedirectImg.jsp'

    // ошибка по умолчанию, если API какую-то чушь вернуло
    var DEFAULT_ERROR_MESSAGE = 'Сервис временно недоступен'

    // добавляем картинку, которая установит Cookie для возврата, куда нужно
    // var redirectUrl =
    //   REDIRECT_URL + (REDIRECT_URL.indexOf('?') >= 0 ? '&' : '?') + 'system=robokassa'
    // var imgSrc =
    //   ROBOKASSA_REGISTER_REDIRECT_URL_IMG +
    //   '?redirectUrl=' +
    //   encodeURIComponent(redirectUrl)
    // var img = document.createElement('img')
    // img.src = imgSrc

    //var img = $('<img/>').attr('src', imgSrc).css('display', 'none')
    //$('body').append(img)

    //var form = evt.currentTarget
    //var login = form.elements['pay-login'].value
    //var sum = form.elements['pay-sum'].value.toString().replace(',', '.')
    //var type = form.elements['type'].value

    var login = login_
    var sum = price
    var type = 'sberbank' // 'robokassa'
    REDIRECT_URL =
      window.location.protocol +
      '//' +
      window.location.host +
      `/#/receive_pay_response/?myOrderId=${orderId}&voucher=false`
    //$(form).find('.pay-error').hide()
    var redirectUrl = REDIRECT_URL // + (REDIRECT_URL.indexOf('?') >= 0 ? '&' : '?') + 'system=' + type;
    var req = {
      method: 'paymentPrepare',
      params: {
        system: type,
        redirectUrl: redirectUrl,
        login: login,
        sum: sum,
      },
    }

    //console.log(REDIRECT_URL, login, sum)

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      body: JSON.stringify(req),
    })
      .then((response) => {
        console.log(response)
        if (!response.ok) {
          onError(DEFAULT_ERROR_MESSAGE)
        } else {
          return response.json()
        }
      })
      .then((data) => {
        console.log(data)
        var errorMessage = null
        if (typeof data !== 'object' || !('error' in data)) {
          errorMessage = DEFAULT_ERROR_MESSAGE
        } else if (data.error !== 0) {
          errorMessage = data.errorMessage || DEFAULT_ERROR_MESSAGE
        } else if (!data.redirectUrl) {
          errorMessage = DEFAULT_ERROR_MESSAGE
        }
        if (errorMessage) {
          //$(form).find('.pay-error').text(errorMessage).show();
          onError(errorMessage)
        } else {
          window.location.href = data.redirectUrl
        }
      })
      .catch((e) => {
        console.log(e)
        var errorMessage = DEFAULT_ERROR_MESSAGE
        if (e.responseJSON && e.responseJSON.error !== 500 && e.responseJSON.errorMessage)
          errorMessage = e.responseJSON.errorMessage
        onError(errorMessage)
      })
  } catch (e) {}
  return false
}

export { payWithSber }
